import script from "./SettingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingPage.vue?vue&type=script&setup=true&lang=ts"

import "./SettingPage.vue?vue&type=style&index=0&id=3954ed95&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ljy\\Desktop\\workspace\\JIN-SOLUTIONS\\JMON_MES\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3954ed95"]])

export default __exports__